module.exports = __webpack_public_path__ + "static/media/kamera.b02b6255.jfif";